import { useTheme } from '@mui/material';

import { fontSize } from '@verantos-dev/shared-ui-components/tokens';

import { CheckboxProps } from './Checkbox';

export const useCheckbox = ({
  id,
  displayLabel,
  displayLabelSize = 'normal',
  showBorderBox = true,
  noHover = false,
  onChange,
  labelStyle,
  ...rest
}: CheckboxProps) => {
  const theme = useTheme();
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(id, event.target.checked);
  };

  const _labelStyle: React.CSSProperties = {
    ...labelStyle,
    fontSize:
      displayLabelSize === 'small'
        ? `${fontSize[12]}px`
        : displayLabelSize === 'medium'
        ? `${fontSize[14]}px`
        : `${fontSize[16]}px`,
    color: rest.disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    cursor: rest.disabled ? 'default' : 'pointer',
  };

  return {
    onChangeHandler,
    labelStyle: _labelStyle,
    id,
    displayLabel,
    showBorderBox,
    noHover,
    ...rest,
  };
};
